import usePaginationSearchParams from 'common/hooks/usePaginationSearchParams';
import { HeadCell } from 'common/types/MuiComponents';
import LoadingContainer from 'common/components/LoadingContainer/LoadingContainer';
import DataTable from 'common/components/DataTable/DataTable';
import { formatDateTime } from 'common/helpers/dateTime';
import { getBags } from 'store/samples/actions';
import { RootState } from 'store';

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, TableCell, TableRow, Typography } from '@mui/material';

const Bags: React.FC = () => {
  const dispatch = useDispatch();
  const { pageParam, rowsParam } = usePaginationSearchParams();

  const fetchBags = useCallback(() => {
    dispatch(getBags(pageParam, rowsParam));
  }, [ dispatch, pageParam, rowsParam ]);

  const { bags, pagination, isLoading, error } = useSelector((store: RootState) => store.samples);

  const headCells = useMemo((): HeadCell[] => [
    {
      id: 'bagId',
      numeric: false,
      label: 'Bag id',
    },
    {
      id: 'bag',
      numeric: false,
      label: 'Bag',
    },
    {
      id: 'createdAt',
      numeric: false,
      label: 'Created at',
    },
  ], []);

  const renderRows = useCallback(() => bags
    .map((row) => {
      return (
        <TableRow hover tabIndex={-1} key={row.id}>
          <TableCell>
            <Typography variant="textSRegular">
              {row.id}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="textSRegular">
              {row.bagId}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="textSRegular">
              {formatDateTime(row.createdAt)}
            </Typography>
          </TableCell>
        </TableRow>
      );
    }), [ bags ]);

  return (
    <LoadingContainer isLoading={isLoading}>

      { error && (
        <Grid item xs={12} padding={2}>
          <Typography color="error" variant="subtitle2" sx={{ whiteSpace: 'break-spaces' }}>
            {error}
          </Typography>
        </Grid>
      )}

      <DataTable
        pagination={pagination}
        headCells={headCells}
        renderRows={renderRows}
        updateDataCallback={fetchBags}
      />

    </LoadingContainer>
  );
};

export default Bags;
